import * as React from 'react';
import classNames from 'classnames';

interface Props {
  label: string;
  choices: { [value: string]: string; };
  selected: Set<string>;
  onChange: (selected: Set<string>) => void;
  isChoiceDisabled?: (choice: string) => boolean;
}

export default ({ label, choices, selected, onChange, isChoiceDisabled }: Props) => {
  return (
    <div className="row">
      <label className="col-sm-3 control-label">{label}</label>
      <div className="col-sm-9">
        {Object.keys(choices).map(choice => (
          <div key={choice} className={classNames(
            'form-check checkbox-inline',
            { disabled: isChoiceDisabled && isChoiceDisabled(choice) },
          )}>
            <label className="form-check-label">
              <input
                className="form-check-input"
                type="checkbox"
                checked={selected.has(choice)}
                disabled={isChoiceDisabled && isChoiceDisabled(choice)}
                onClick={(evt: any) => {
                  const newSelected = new Set(selected);
                  evt.target.checked ? newSelected.add(choice) : newSelected.delete(choice);
                  onChange(newSelected);
                }}
              />
              <span className="form-check-sign" />
              {choices[choice]}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
